import React, { useState, useEffect, useCallback } from 'react';
import { useInView } from './useParallax';
import { DiamondDivider } from './svgs';
import './Gallery.css';

const ALL_IMAGES = [
  { src: '/images/community-spotlight-1.jpeg', label: 'Community Gathering',           cat: 'events',     span: 'spotlight' },
  { src: '/images/community-spotlight-2.jpeg', label: 'Community Celebration',         cat: 'events',     span: 'spotlight' },
  { src: '/images/Ashram 2.jpeg',              label: 'Arunachala at Dawn',            cat: 'arunachala', span: 'wide' },
  { src: '/images/Sriramanavami 3.jpeg',        label: 'Sri Ramanavami Celebration',    cat: 'events',     span: 'wide' },
  { src: '/images/Ashram Prasad 2.jpeg',        label: 'Prasadam Shrine',               cat: 'prasadam',   span: 'normal' },
  { src: '/images/Shrirama Dhama .jpeg',        label: 'Shrirama Dhama',                cat: 'devotion',   span: 'normal' },
  { src: '/images/Shrirama Dhama whole.jpeg',   label: 'Book Distribution Seva',        cat: 'prasadam',   span: 'wide' },
  { src: '/images/IMG_4247.JPG',                label: 'Sacred Shiva Lingam',           cat: 'devotion',   span: 'normal' },
  { src: '/images/IMG_4261.JPG',                label: 'Deity Altar',                   cat: 'devotion',   span: 'normal' },
  { src: '/images/IMG_4349.JPG',                label: 'Sacred Arunachala',             cat: 'arunachala', span: 'wide' },
  { src: '/images/IMG_4294.JPG',                label: 'Sunset Blossoms',               cat: 'arunachala', span: 'normal' },
  { src: '/images/IMG_4343.JPG',                label: 'Prasadam Hall',                 cat: 'prasadam',   span: 'normal' },
  { src: '/images/IMG_4255.JPG',                label: 'Prasadam Hall at Golden Hour',  cat: 'prasadam',   span: 'normal' },
  { src: '/images/IMG_4242.JPG',                label: 'Meditation Pavilion',           cat: 'ashram',     span: 'normal' },
  { src: '/images/IMG_4384.JPG',                label: 'Vedanagari Ashram',             cat: 'ashram',     span: 'normal' },
  { src: '/images/IMG_4219.JPG',                label: 'Arunachala Shrirama Dhama',     cat: 'ashram',     span: 'normal' },
  { src: '/images/IMG_4220.JPG',                label: 'Ashram Gateway',                cat: 'ashram',     span: 'normal' },
  { src: '/images/IMG_4325.JPG',                label: 'Atmanivas — Rising',            cat: 'ashram',     span: 'normal' },
  { src: '/images/IMG_4363.JPG',                label: 'Ashram Building',               cat: 'ashram',     span: 'normal' },
  { src: '/images/IMG_4228.JPG',                label: 'Girivalam Path',                cat: 'ashram',     span: 'normal' },
  { src: '/images/IMG_4229.JPG',                label: 'Hanuman at the Entrance',       cat: 'ashram',     span: 'normal' },
  { src: '/images/IMG_4253.JPG',                label: 'Ashram Gardens',                cat: 'ashram',     span: 'normal' },
  { src: '/images/IMG_4257.JPG',                label: 'Ashram Grounds',                cat: 'ashram',     span: 'normal' },
  { src: '/images/IMG_4263.JPG',                label: 'At the Ashram',                 cat: 'ashram',     span: 'normal' },
  { src: '/images/IMG_4326.JPG',                label: 'Ashram View',                   cat: 'ashram',     span: 'normal' },
  { src: '/images/IMG_4345.JPG',                label: 'Ashram Scene',                  cat: 'ashram',     span: 'normal' },
  { src: '/images/IMG_4358.JPG',                label: 'Girivalam Scene',               cat: 'ashram',     span: 'normal' },
  { src: '/images/IMG_4361.JPG',                label: 'Devotion',                      cat: 'devotion',   span: 'normal' },
  { src: '/images/IMG_4370.JPG',                label: 'Ashram Life',                   cat: 'ashram',     span: 'normal' },
];

const FILTERS = [
  { key: 'all',       label: 'All Moments' },
  { key: 'arunachala', label: 'Arunachala' },
  { key: 'ashram',    label: 'Ashram' },
  { key: 'prasadam',  label: 'Prasadam & Seva' },
  { key: 'devotion',  label: 'Devotion' },
  { key: 'events',    label: 'Events' },
];

function Lightbox({ images, index, onClose, onPrev, onNext }) {
  const img = images[index];

  useEffect(() => {
    const handler = (e) => {
      if (e.key === 'Escape') onClose();
      if (e.key === 'ArrowLeft') onPrev();
      if (e.key === 'ArrowRight') onNext();
    };
    window.addEventListener('keydown', handler);
    document.body.style.overflow = 'hidden';
    return () => {
      window.removeEventListener('keydown', handler);
      document.body.style.overflow = '';
    };
  }, [onClose, onPrev, onNext]);

  return (
    <div className="lightbox" onClick={onClose}>
      <button className="lightbox__close cinzel" onClick={onClose} aria-label="Close">✕</button>

      <button
        className="lightbox__nav lightbox__nav--prev"
        onClick={e => { e.stopPropagation(); onPrev(); }}
        aria-label="Previous"
      >‹</button>

      <div className="lightbox__stage" onClick={e => e.stopPropagation()}>
        <img
          className="lightbox__img"
          src={img.src}
          alt={img.label}
        />
        <p className="lightbox__label cinzel">{img.label}</p>
        <p className="lightbox__counter">{index + 1} / {images.length}</p>
      </div>

      <button
        className="lightbox__nav lightbox__nav--next"
        onClick={e => { e.stopPropagation(); onNext(); }}
        aria-label="Next"
      >›</button>
    </div>
  );
}

function GalleryCard({ image, globalIndex, onClick, animDelay }) {
  const [ref, inView] = useInView(0.1);

  return (
    <div
      ref={ref}
      className={`gallery-card gallery-card--${image.span} ${inView ? 'gallery-card--visible' : ''}`}
      style={{ transitionDelay: `${animDelay}s` }}
      onClick={() => onClick(globalIndex)}
      role="button"
      tabIndex={0}
      onKeyDown={e => e.key === 'Enter' && onClick(globalIndex)}
      aria-label={`View ${image.label}`}
    >
      <div className="gallery-card__img-wrap">
        <img
          className="gallery-card__img"
          src={image.src}
          alt={image.label}
          loading="lazy"
        />
        <div className="gallery-card__warm-overlay" />
        <div className="gallery-card__overlay">
          <span className="gallery-card__label cinzel">{image.label}</span>
          <span className="gallery-card__expand">⊕</span>
        </div>
      </div>
    </div>
  );
}

export default function Gallery() {
  const [activeFilter, setActiveFilter] = useState('all');
  const [lightboxIndex, setLightboxIndex] = useState(null);
  const [headerRef, headerInView] = useInView(0.1);

  const filtered = activeFilter === 'all'
    ? ALL_IMAGES
    : ALL_IMAGES.filter(img => img.cat === activeFilter);

  const openLightbox = useCallback((index) => setLightboxIndex(index), []);
  const closeLightbox = useCallback(() => setLightboxIndex(null), []);
  const prevImage = useCallback(() =>
    setLightboxIndex(i => (i - 1 + filtered.length) % filtered.length), [filtered.length]);
  const nextImage = useCallback(() =>
    setLightboxIndex(i => (i + 1) % filtered.length), [filtered.length]);

  return (
    <section className="gallery-section" id="community">
      <div className="section-container">
        {/* Header */}
        <div
          ref={headerRef}
          className={`gallery-section__header ${headerInView ? 'gallery-section__header--visible' : ''}`}
        >
          <p className="gallery-section__eyebrow cinzel">Moments of Grace</p>
          <h2 className="gallery-section__title cinzel">
            Our <span className="gallery-section__accent">Community</span>
          </h2>
          <DiamondDivider color="#C9902A" />
          <p className="gallery-section__intro">
            Every image is a living moment — the mountain, the flame, the meals shared,
            the prayers offered. Vedanagari in its everyday grace.
          </p>
        </div>

        {/* Filter tabs */}
        <div className="gallery-filters">
          {FILTERS.map(f => (
            <button
              key={f.key}
              className={`gallery-filter cinzel ${activeFilter === f.key ? 'gallery-filter--active' : ''}`}
              onClick={() => { setActiveFilter(f.key); setLightboxIndex(null); }}
            >
              {f.label}
            </button>
          ))}
        </div>

        {/* Grid */}
        <div className="gallery-grid">
          {filtered.map((img, i) => (
            <GalleryCard
              key={img.src}
              image={img}
              globalIndex={i}
              onClick={openLightbox}
              animDelay={Math.min(i * 0.06, 0.5)}
            />
          ))}
        </div>
      </div>

      {/* Lightbox */}
      {lightboxIndex !== null && (
        <Lightbox
          images={filtered}
          index={lightboxIndex}
          onClose={closeLightbox}
          onPrev={prevImage}
          onNext={nextImage}
        />
      )}
    </section>
  );
}
